import { COLORS } from '~/data/ui/colors';

export const useStyles = () => ({
  '&.Mui-selected, &.Mui-selected:hover': {
    color: COLORS.green.dark,
    backgroundColor: COLORS.black.main,
  },
  root: {
    border: `1.29396px solid ${COLORS.gray.light2}`,
    borderRadius: '12px',
    padding: '5px',
    marginTop: '8px',
    maxWidth: '600px',
    width: 220,
    gap: '3px',
  },
});

export const ToggleButtonGroupStyle = {
  borderRadius: '12px',
  background: COLORS.white.main,
};
export const buttonItem = {
  borderRadius: '8px',
  width: '50%',
  '&.MuiToggleButtonGroup-grouped': {
    border: '1px solid transparent',
    borderRadius: '8px',
  },
  '&.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
    borderRadius: '8px !important',
  },
  gap: '8px',
  '&.Mui-selected, &.Mui-selected:hover': {
    boxSizing: 'border-box',
    background: COLORS.primary.main,
    border: `2px solid ${COLORS.primary.main}`,
    borderRadius: '8px !important',
    color: COLORS.black.dark,
  },
};
